!(function (win, doc) {
  var fireCustomEvent = function (eventName) {
    var dsEvent,
      dsEventName = eventName;
    if (document.createEvent) {
      dsEvent = document.createEvent('HTMLEvents');
      dsEvent.initEvent(dsEventName, false, false);
      document.dispatchEvent(dsEvent);
    } else {
      document.documentElement[eventName]++;
    }
  };

  var CustomEvent = function (event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  var func = function () {
    var d = document.getElementById('diamondinstantinventory');
    var i = doc.createElement('iframe');
    var apiKey = d.getAttribute('data-apikey');

    i.id = 'diamondRapnetIframe';
    i.name = 'diamondRapnetIframe';
    i.width = '100%';
    i.height = '100%';
    i.style = 'border:none;';
    i.setAttribute('data-apikey', apiKey);
    i.src = 'https://ii.api.prod.rapnet.com/api/Feeds/%APPKEY%/Widget#/'.replace('%APPKEY%', apiKey);
    d.appendChild(i);

    i.onload = function () {
      i.contentWindow.postMessage({ apiKey: apiKey }, '*');
      fireCustomEvent('ds.ready');

      window.addEventListener('message', function (event) {
        try {
          var o = JSON.parse(event.data);

          if (o.eventName === 'ds.addtocart') {
            window.dispatchEvent(
              CustomEvent('ds.addtocart', {
                detail: {
                  diamond: o.item
                }
              })
            );
          }
        } catch (e) {
          console.error('event error', e);
        }
      });
    };
  };
  if (document.readyState === 'complete') {
    func();
  } else {
    window.addEventListener('load', function () {
      func();
    });
  }
})(window, document);
